// src/components/common/PWAInstallPrompt.js
import React from 'react';
import { Download, X, Share, PlusSquare } from 'lucide-react';
import { usePWA } from '../../context/PWAContext';
import './PWAInstallPrompt.css'; // ✅ IMPORT THE NEW CSS FILE

const PWAInstallPrompt = () => {
  const { isIOS, isStandalone, isDismissed, promptInstall, dismissPrompt } = usePWA();

  // If already installed OR user clicked 'Later', DO NOT show the popup
  if (isStandalone || isDismissed) return null;

  return (
    <>
      {/* --- ANDROID / DESKTOP INSTALL MODAL --- */}
      {!isIOS && (
        <div className="pwa-overlay">
          <div className="pwa-modal">
            <div className="pwa-header">
              <div className="pwa-header-left">
                 <div className="pwa-logo-wrapper">
                   {/* Make sure this image path points to your actual logo in the public folder */}
                   <img src="/logo512.png" alt="BookMyAudition" />
                 </div>
                 <h3>Install App</h3>
              </div>
              <button onClick={dismissPrompt} className="pwa-close-btn">
                <X size={20} />
              </button>
            </div>
            
            <div className="pwa-body">
              <p>
                Install <strong>BookMyAudition</strong> for a smoother experience, instant access to roles, and offline capabilities.
              </p>
              
              <div className="pwa-actions">
                <button onClick={dismissPrompt} className="pwa-btn pwa-btn-later">
                  Later
                </button>
                <button 
                  onClick={() => { promptInstall(); dismissPrompt(); }} 
                  className="pwa-btn pwa-btn-install"
                >
                  <Download size={18} /> Install Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --- IOS INSTALL MODAL --- */}
      {isIOS && (
        <div className="pwa-overlay">
          <div className="pwa-modal">
            <div className="pwa-header">
              <div className="pwa-header-left">
                 <div className="pwa-logo-wrapper">
                    <img src="/bma_logo_1.png" alt="BookMyAudition" />
                 </div>
                 <h3>Install on iOS</h3>
              </div>
              <button onClick={dismissPrompt} className="pwa-close-btn">
                <X size={20} />
              </button>
            </div>
            
            <div className="pwa-body">
              <p>Install <strong>BookMyAudition</strong> on your iPhone for the best auditioning experience.</p>
              
              <div className="pwa-ios-instructions">
                <div className="pwa-ios-step">
                  <div className="pwa-ios-icon-wrapper"><Share size={18} color="#3b82f6" /></div>
                  <div><strong>1.</strong> Tap the <strong>Share</strong> button in Safari.</div>
                </div>
                <div className="pwa-ios-step">
                   <div className="pwa-ios-icon-wrapper"><PlusSquare size={18} color="#a0a0a0" /></div>
                  <div><strong>2.</strong> Scroll down and tap <strong>"Add to Home Screen"</strong>.</div>
                </div>
              </div>
              
              <div className="pwa-actions">
                <button onClick={dismissPrompt} className="pwa-btn pwa-btn-got-it">
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PWAInstallPrompt;